import { render, staticRenderFns } from "./wjGlue.vue?vue&type=template&id=05648552&scoped=true"
import script from "./wjGlue.vue?vue&type=script&lang=js"
export * from "./wjGlue.vue?vue&type=script&lang=js"
import style0 from "./wjGlue.vue?vue&type=style&index=0&id=05648552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05648552",
  null
  
)

export default component.exports